import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../AuthContext";

// minPlan: the lowest plan that unlocks this report
const REPORTS = [
    { planKey: 'report_purchase',    minPlan: 'Starter',       title: 'Purchase Report',    subtitle: 'Dealer purchase history & inventory',       icon: 'fas fa-store',              color: '#ffc107', path: '/reports/purchase'    },
    { planKey: 'report_sales',       minPlan: 'Starter',       title: 'Sales Report',       subtitle: 'Billing & vehicle sales summary',           icon: 'fas fa-chart-line',         color: '#28a745', path: '/reports/sales'       },
    { planKey: 'report_stock',       minPlan: 'Starter',       title: 'Stock Report',       subtitle: 'Current stock & inventory status',          icon: 'fas fa-warehouse',          color: '#007bff', path: '/reports/stock'       },
    { planKey: 'report_outstanding', minPlan: 'Professional',  title: 'Outstanding Report', subtitle: 'Pending EMIs & overdue collections',        icon: 'fas fa-exclamation-circle', color: '#dc3545', path: '/reports/outstanding' },
    { planKey: 'report_collection',  minPlan: 'Professional',  title: 'Collection Report',  subtitle: 'All EMI receipts & payments collected',     icon: 'fas fa-receipt',            color: '#17a2b8', path: '/reports/collection'  },
];

export default function Reports() {
    const navigate = useNavigate();
    const { isPlanAllowed, planName } = useContext(AuthContext);

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">
                                <i className="fas fa-chart-bar text-primary mr-2"></i>Reports
                            </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/dashboard">Home</a></li>
                                <li className="breadcrumb-item active">Reports</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid">
                    {planName && (
                        <div className="alert alert-info py-2 mb-3">
                            <i className="fas fa-crown mr-1"></i>
                            Current Plan: <strong>{planName}</strong>
                        </div>
                    )}
                    <div className="row">
                        {REPORTS.map(r => {
                            const allowed = isPlanAllowed(r.planKey);
                            return (
                                <div key={r.planKey} className="col-md-6 col-lg-4 mb-4">
                                    <div
                                        className={`card elevation-2 h-100 ${!allowed ? 'border-secondary' : ''}`}
                                        style={{
                                            cursor: allowed ? 'pointer' : 'default',
                                            borderLeft: `4px solid ${allowed ? r.color : '#adb5bd'}`,
                                            transition: 'transform 0.2s',
                                            opacity: allowed ? 1 : 0.7,
                                        }}
                                        onClick={() => {
                                            if (allowed) navigate(r.path);
                                        }}
                                        onMouseEnter={e => { if (allowed) e.currentTarget.style.transform = 'translateY(-4px)'; }}
                                        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                    >
                                        <div className="card-body d-flex align-items-center">
                                            <div
                                                className="mr-3"
                                                style={{ width: 52, height: 52, borderRadius: 12, background: (allowed ? r.color : '#adb5bd') + '22', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                                            >
                                                <i className={allowed ? r.icon : 'fas fa-lock'} style={{ color: allowed ? r.color : '#adb5bd', fontSize: 22 }}></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h5 className="mb-0 font-weight-bold" style={{ color: allowed ? '' : '#6c757d' }}>{r.title}</h5>
                                                <small className="text-muted">{r.subtitle}</small>
                                                {!allowed && (
                                                    <div className="mt-1">
                                                        <span className="badge badge-secondary" style={{ fontSize: '11px' }}>
                                                            <i className="fas fa-crown mr-1"></i>Requires {r.minPlan} Plan
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                            {allowed
                                                ? <i className="fas fa-chevron-right text-muted ml-2"></i>
                                                : <i className="fas fa-lock text-muted ml-2"></i>
                                            }
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
}
